import { Color, Command, parse, RenderToken, UserMessageInput } from '@hackvegas-2025/shared';

export const state = {
  prompting: false,
  fontsLoaded: false,
  focused: false,
  startupClockMs: 0,
  prompt: '',

  lines: [] as RenderToken[][],
  renderLineTime: 0,
  lastLineShown: 0,

  scrolled: null as null | number,

  color: Color.green as Color,
  availableColors: [Color.green, Color.orange] as Color[], // colors other than green will come from server
  availableCommands: [Command.login, Command.help, Command.info, Command.clear, Command.fullscreen] as Command[],
  code: '',
  send(command: UserMessageInput) {},
};

export type State = typeof state;

export function resetState() {
  state.color = Color.green;
  // state.availableColors = [Color.green];
  state.availableCommands = [Command.login, Command.help, Command.info, Command.clear, Command.fullscreen];
  state.code = '';
  state.send = () => {};
}

export function removeCommand(command: Command) {
  state.availableCommands = state.availableCommands.filter((c) => c !== command);
}

export function log(text: string) {
  const lines = text.split('\n');
  for (const line of lines) {
    state.lines.push(parse(line));
  }
}
